import {Pipe, PipeTransform} from '@angular/core';
import {DateTime} from 'luxon';

@Pipe({
    name: 'whatsAppStatus',
    standalone: true
})
export class WhatsAppStatusPipe implements PipeTransform {

  transform(value: string): string {

    switch (value) {
      case 'APPROVED':
        return 'Approved';
      case 'IN_APPEAL':
        return 'In Appeal';
      case 'PENDING':
        return 'Pending';
      case 'REJECTED':
        return 'Rejected';
      case 'PENDING_DELETION':
        return 'Pending Deletion';
      case 'DELETED':
        return 'Deleted';
      case 'DISABLED':
        return 'Disabled';
      case 'PAUSED':
        return 'Paused';
      case 'LIMIT_EXCEEDED':
        return 'Limit Exceeded';
      default:
        return value;
    }
  }
}
